import { render, staticRenderFns } from "./TermGradeRule.vue?vue&type=template&id=0e856086"
import script from "./TermGradeRule.vue?vue&type=script&lang=js"
export * from "./TermGradeRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports